import { intakeFormBackThunk } from 'actions/intakeForm/IntakeFormActions';
import { heroGirlKissingDog } from 'assets/images';
import { IntakeFormAddPet } from 'components/IntakeForm/AddPet/IntakeFormAddPet';
import { IntakeFormCustomer } from 'components/IntakeForm/Customer/IntakeFormCustomer';
import { IntakeFormPetList } from 'components/IntakeForm/PetList/IntakeFormPetList';
import { IntakeFormSuccess } from 'components/IntakeForm/Success/IntakeFormSuccess';
import { Header } from 'components/Layout/Header/Header';
import { TwoColumnsLayout } from 'components/Layout/TwoColumns/TwoColumnsLayout';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIntakeFormProgress, getIntakeFormStep } from 'reducers/intakeForm/IntakeFormSelectors';
import { IntakeFormStep } from 'reducers/intakeForm/IntakeFormState';
import { getMarketplace } from 'reducers/marketplace/MarketplaceSelectors';

export const IntakeForm: React.FC = () => {
    const dispatch = useDispatch();
    const marketplace = useSelector(getMarketplace);
    const currentStep = useSelector(getIntakeFormStep);
    const progress = useSelector(getIntakeFormProgress);

    const isBackEnabled = [IntakeFormStep.AddPetForm, IntakeFormStep.PetList].includes(currentStep);

    const backHandler = () => dispatch(intakeFormBackThunk());

    const renderLeftColumn = () => {
        switch (currentStep) {
            case IntakeFormStep.CustomerForm:
                return <IntakeFormCustomer />;
            case IntakeFormStep.AddPetForm:
                return <IntakeFormAddPet />;
            case IntakeFormStep.PetList:
                return <IntakeFormPetList />;
            case IntakeFormStep.Success:
                return <IntakeFormSuccess />;
        }
    };

    return (
        <TwoColumnsLayout
            header={
                <Header
                    progress={progress}
                    logo={marketplace.logo}
                    onBack={isBackEnabled ? backHandler : undefined}
                />
            }
            leftColumn={renderLeftColumn()}
            rightColumnImage={heroGirlKissingDog}
        />
    );
};
